import { useMutation } from 'react-query';

import { deleteGateTemplate as mutationFn } from 'api/endPoints/deleteGateTemplate';

export const useMutationDeleteTemplate = () => {
    return useMutation<unknown, QueryError, number>((templateId) => mutationFn(templateId));
};
